/* Native Shopify discount links and UAE-local, calendar-day delivery dates. */
(() => {
  'use strict';
  function deliveryDates(now, cutoff = 16, timeZone = 'Asia/Dubai') {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23'
    }).formatToParts(now).reduce((value, part) => { value[part.type] = part.value; return value; }, {});
    const today = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const afterCutoff = Number(parts.hour) >= cutoff;
    const processing = new Date(today);
    processing.setUTCDate(processing.getUTCDate() + (afterCutoff ? 1 : 0));
    const delivered = new Date(processing);
    delivered.setUTCDate(delivered.getUTCDate() + 1);
    return { today, processing, delivered, afterCutoff };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { deliveryDates };
  if (typeof customElements === 'undefined') return;

  class GsExtraOffer extends HTMLElement {
    connectedCallback() {
      const link = this.querySelector('a');
      if (!link) return;
      const destination = new URL(window.location.href);
      destination.searchParams.set('variant', this.dataset.variant);
      const theme = window.Shopify?.theme;
      if (theme?.role === 'unpublished' || theme?.role === 'development') {
        destination.searchParams.set('preview_theme_id', theme.id);
      }
      destination.hash = '';
      const discount = new URL(link.href);
      // Keep the current variant and draft preview when returning from Shopify's discount route.
      discount.searchParams.set('redirect', destination.pathname + destination.search);
      link.href = discount.href;
    }
  }
  class GsDeliveryTimeline extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const cutoff = Number(this.dataset.cutoff || 16);
        const dates = deliveryDates(new Date(), cutoff, this.dataset.timezone);
        const short = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', timeZone: 'UTC' });
        const long = new Intl.DateTimeFormat('en-GB', { weekday: 'long', day: 'numeric', month: 'short', timeZone: 'UTC' });
        const summary = this.querySelector('[data-delivery-summary]');
        const strong = document.createElement('strong');
        strong.textContent = long.format(dates.delivered);
        summary.replaceChildren(document.createTextNode('Order today for UAE delivery on '), strong);
        this.querySelector('[data-delivery-processing]').textContent = short.format(dates.processing);
        this.querySelector('[data-delivery-date]').textContent = short.format(dates.delivered);
        const hour = `${cutoff % 12 || 12} ${cutoff >= 12 ? 'PM' : 'AM'}`;
        this.querySelector('[data-delivery-cutoff]').textContent = dates.afterCutoff
          ? `Today's ${hour} UAE cutoff has passed. Orders placed now process tomorrow.`
          : `Order before ${hour} UAE time for next-day delivery.`;
        this.querySelector('.gs-delivery__steps').hidden = false;
        this.dataset.deliveryDate = dates.delivered.toISOString().slice(0, 10);
        this.dataset.processingDate = dates.processing.toISOString().slice(0, 10);
        clearTimeout(this.timer);
        // Recalculate at each minute boundary, including cutoff and Dubai midnight.
        this.timer = setTimeout(this.update, 60000 - Date.now() % 60000 + 50);
      };
      this.update();
      document.addEventListener('visibilitychange', this.update);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.update);
    }
  }
  if (!customElements.get('gs-extra-offer')) customElements.define('gs-extra-offer', GsExtraOffer);
  if (!customElements.get('gs-delivery-timeline')) customElements.define('gs-delivery-timeline', GsDeliveryTimeline);
})();
